<div class="inner-content">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="goToBack()">
        <ion-icon slot="start" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title id="modal-title" class="ion-text-center ion-no-padding ion-text-uppercase fs-pt-16">{{modalTitle}}</ion-title>
  </ion-toolbar>


  <ion-grid>
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ion-col size-sm="12" size-xl="6" size-md="8">

        <ion-item >
          <ion-label position="stacked">{{ 'shared.dettaglio_ricarica.data' | transloco }}</ion-label>
          <ion-text >{{ formatData(currentRicarica.data) }}</ion-text>
        </ion-item>

        <ion-item >
          <ion-label position="stacked">{{ 'shared.dettaglio_ricarica.numeroBollettino' | transloco }}</ion-label>
          <ion-text > {{currentRicarica.numero_bollettino}}</ion-text>
        </ion-item>

        <ion-item >
          <ion-label position="stacked" >{{ 'shared.dettaglio_ricarica.operatore' | transloco }}</ion-label>
          <ion-text >{{currentRicarica.operatore}}</ion-text>
        </ion-item>

        <ion-item >
          <ion-label position="stacked">{{ 'shared.dettaglio_ricarica.valore' | transloco }}</ion-label>
          <ion-text >{{currentRicarica.valore}}</ion-text>
        </ion-item>

        <ion-item >
          <ion-label position="stacked">{{ 'shared.dettaglio_ricarica.note' | transloco }}</ion-label>
          <ion-text >{{currentRicarica.note}}</ion-text>
        </ion-item>

        <ion-accordion-group>
          <ion-accordion value="first">
            <ion-item slot="header">
              <ion-label><b>{{ 'shared.dettaglio_ricarica.aggiornamenti' | transloco }}</b></ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              @for (aggiornmento of currentRicarica.aggiornamenti; track aggiornmento; let i = $index) {
                <ion-item >
                  <ion-label position="stacked">{{ 'shared.dettaglio_ricarica.dataOperazione' | transloco }}</ion-label>
                  <ion-text >{{ formatDataOra(aggiornmento.data_operazione) }}</ion-text>
                </ion-item>
                <ion-item >
                  <ion-label position="stacked">{{ 'shared.dettaglio_ricarica.commentoOperatore' | transloco }}</ion-label>
                  <ion-text >{{aggiornmento.commento_operatore}}</ion-text>
                </ion-item>
                <ion-item >
                  <ion-label position="stacked">{{ 'shared.dettaglio_ricarica.operazione' | transloco }}</ion-label>
                  <ion-text >{{joinOperazioni(aggiornmento.operazioni)}}</ion-text>
                </ion-item>
                @if (!!currentRicarica.aggiornamenti && (i < (currentRicarica.aggiornamenti.length - 1))) {
                  <hr class="new1 ion-margin-top">
                }
              }

            </div>
          </ion-accordion>
        </ion-accordion-group>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
